import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {DELETE_NOTIFICATION_ERROR, DELETE_NOTIFICATION_START, DELETE_NOTIFICATION_SUCCESS} from "../../types";

export function* deleteBanner({payload}) {
    try {
        const url = `/notifications/${payload.id}/`;
        const method = 'DELETE';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
        const results = yield call(apiCall, url, method, payload.formData, headers);
        yield put({type: DELETE_NOTIFICATION_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/content-management/manage-notifications'));
    } catch (error) {
        yield put({type: DELETE_NOTIFICATION_ERROR, error});
    }
}

export default function* delete_banner() {
    yield takeLatest(DELETE_NOTIFICATION_START, deleteBanner);
}